/**
 * External-link opener. `window.open(url, '_blank')` opens a real browser tab on the web, but in an
 * Android WebView it's unreliable (often a no-op or a blank in-app view). The host app injects a
 * shell-aware opener via `setExternalOpener` — on Tauri that's the system-browser opener
 * (tauri-plugin-opener) — so downloaded files and outbound links open correctly everywhere. `ui`
 * stays free of any Tauri dependency; the default is the plain web behavior.
 */
export type ExternalOpener = (url: string) => void;

let opener: ExternalOpener = (url) => {
  window.open(url, '_blank', 'noopener');
};

/** Host app overrides how external URLs open (e.g. system browser on Tauri). */
export function setExternalOpener(fn: ExternalOpener): void {
  opener = fn;
}

/** Open an external URL using the configured opener (web tab by default). */
export function openExternal(url: string): void {
  opener(url);
}
